'use client';

import { toPascalCase } from '@/utils/string-utils';
import { IBaseComponentProps, WithMetadata } from '@/lib/types';
import { IFooter } from '@/.generated';
import { StickyTileModal } from './StickyTileModal';
import { StickyTile } from './StickyTile';
import { stickyTilesVariants } from './StickyTiles.styles';
import { useAccountLogin } from '@/lib/hooks/useAccountLogin';

type StickyTilesProps = WithMetadata<IBaseComponentProps> & IFooter['sticky_tiles_section'];

const { container } = stickyTilesVariants();

const Default = (props: StickyTilesProps) => {
  const { log_in_tile, account_tile, pay_bill_tile, outages_tile, call_srp_tile } = props;

  const userLoggedIn = useAccountLogin();

  return (
    <div className={container()}>
      {!userLoggedIn && <StickyTileModal tile={log_in_tile} />}
      {userLoggedIn && <StickyTile tile={account_tile} />}
      <StickyTile tile={pay_bill_tile} />
      <StickyTile tile={outages_tile} />
      <StickyTile tile={call_srp_tile} />
    </div>
  );
};

const variants = {
  Default,
};

export const StickyTiles = (props: StickyTilesProps) => {
  const Component = props.component_variant
    ? variants[toPascalCase(props.component_variant) as keyof typeof variants]
    : Default;
  return <Component {...props} />;
};
